import { useRef } from 'react';
import { AutoCenter } from '../auto-center';
import { Button, ButtonProps } from '../button/button';
import { dialogPageSpinner } from '../dialog/page-spinner';
import './style.less';

export type PageErrorProps = {
  message?: string;
  className?: string;
  btnName?: string;
  buttonProps?: ButtonProps;
};

export const PageErrorView = (props: PageErrorProps) => {
  const rootRef = useRef<HTMLDivElement>(null);

  const onClick = (e) => {
    if (props.buttonProps?.onClick) {
      void props.buttonProps?.onClick(e);
    } else {
      dialogPageSpinner.show();
      window.location.reload();
    }
  };

  return (
    <div className="v-dialog-page-error" ref={rootRef}>
      <div className="v-dialog-page-error-content">
        <div className="v-dialog-page-error-icon"></div>
        <AutoCenter className="v-dialog-page-error-message">
          <div dangerouslySetInnerHTML={{ __html: props?.message || '未知异常，请稍后再使用' }}></div>
        </AutoCenter>
        <div className="v-dialog-page-error-operate">
          <Button type="primary" {...props.buttonProps} onClick={onClick}>
            {props?.btnName || '重新获取'}
          </Button>
        </div>
      </div>
    </div>
  );
};
